import { Component, OnInit, Signal } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from '@vinnova/auth';
import { ChatbotService } from '@vinnova/chatbot';
import { EtjansterSites } from '@vinnova/e-tjanster';
import { take } from 'rxjs';
import { environment } from '../../environments/environment';
import { InternalService } from '../core/services/internal.service';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent implements OnInit {
  hasError = false;
  isProduction: boolean;
  hasValidAccount: boolean;
  isInternal: Signal<boolean>;

  EtjansterSites = EtjansterSites;
  showChatbot = false;

  constructor(
    private authService: AuthService,
    private internalService: InternalService,
    private chatbotService: ChatbotService,
  ) {}

  ngOnInit() {
    this.isProduction = environment.production;
    this.authService
      .hasValidAccountAndActiveCookie()
      .pipe(take(1))
      .subscribe((hasValidAccountAndActiveCookie) => {
        this.hasValidAccount = hasValidAccountAndActiveCookie;
      });
    this.isInternal = this.internalService.getIsInternal();

    this.chatbotService.isAvailable$
      .pipe(untilDestroyed(this))
      .subscribe((isAvailable) => {
        this.showChatbot = isAvailable;
      });
  }
}
